import { Component, OnInit } from '@angular/core';
import {OfferBasicBoxComponent} from '../../offer-section/boxes/offer-basic-box/offer-basic-box.component';
import {LanguageService} from '../../../../services/language.service';

@Component({
  selector: 'app-next-offer-detail-box',
  templateUrl: './next-offer-detail-box.component.html',
  styleUrls: []
})
export class NextOfferDetailBoxComponent extends OfferBasicBoxComponent implements OnInit {

  icon: string;
  value: string = null;

  constructor(private lang: LanguageService) {
    super(lang);
  }

  ngOnInit() {
    this.setLabel();
    this.setSelectedOption();
    this.setAdditionalInfo();
  }

  get isValueAmount(): boolean {
    return typeof this.value === 'number';
  }

  private setAdditionalInfo() {
    this.value = this.lang.getTranslationForKey(this.selectedOption.values, 'value');
  }

}
